import { SLASH } from "~/shared/str";

const BASE_URL = "auth";

const URLS = {
  register: [BASE_URL, "register"].join(SLASH),
  login: [BASE_URL, "login"].join(SLASH),
  logout: [BASE_URL, "logout"].join(SLASH),
  changePassword: [BASE_URL, "change-password"].join(SLASH),
  resetPassword: [BASE_URL, "reset-password"].join(SLASH),
  getMe: [BASE_URL, "getCurrentUser"].join(SLASH),
};

export { URLS };
